// GENERATED FILE, PLEASE DO NOT EDIT
var BannerDefault = 8;
var ButtonTabDefault = 8;
var ButtonTabSelectionIndicator = 4;
var ButtonToggleDefault = 4;
var ButtonToggleGroupLarge = 24;
var ButtonToggleGroupMedium = 20;
var ButtonToggleGroupSmall = 16;
var ButtonDefault = 4;
var IconButtonDefault = 4;
var CardDefault = 8;
var FieldsInputDefault = 8;
var FieldsInputConnectedWrapperDefault = 8;
var ModalDefault = 16;
var PaginationDefault = 20;
var PopoverContainerDefault = 8;
var TagDefault = 4;
var ToastContainer = 24;
var ToggleTypeCheckbox = 4;
var ToggleTypeToggle = 24;
var TooltipContainer = 8;
var TooltipButtonClose = 24;
var BorderRadiusSemanticsAll = {
  BannerDefault: BannerDefault,
  ButtonDefault: ButtonDefault,
  ButtonTabDefault: ButtonTabDefault,
  ButtonTabSelectionIndicator: ButtonTabSelectionIndicator,
  ButtonToggleDefault: ButtonToggleDefault,
  ButtonToggleGroupLarge: ButtonToggleGroupLarge,
  ButtonToggleGroupMedium: ButtonToggleGroupMedium,
  ButtonToggleGroupSmall: ButtonToggleGroupSmall,
  CardDefault: CardDefault,
  FieldsInputConnectedWrapperDefault: FieldsInputConnectedWrapperDefault,
  FieldsInputDefault: FieldsInputDefault,
  IconButtonDefault: IconButtonDefault,
  ModalDefault: ModalDefault,
  PaginationDefault: PaginationDefault,
  PopoverContainerDefault: PopoverContainerDefault,
  TagDefault: TagDefault,
  ToastContainer: ToastContainer,
  ToggleTypeCheckbox: ToggleTypeCheckbox,
  ToggleTypeToggle: ToggleTypeToggle,
  TooltipButtonClose: TooltipButtonClose,
  TooltipContainer: TooltipContainer
};

export { BannerDefault, BorderRadiusSemanticsAll, ButtonDefault, ButtonTabDefault, ButtonTabSelectionIndicator, ButtonToggleDefault, ButtonToggleGroupLarge, ButtonToggleGroupMedium, ButtonToggleGroupSmall, CardDefault, FieldsInputConnectedWrapperDefault, FieldsInputDefault, IconButtonDefault, ModalDefault, PaginationDefault, PopoverContainerDefault, TagDefault, ToastContainer, ToggleTypeCheckbox, ToggleTypeToggle, TooltipButtonClose, TooltipContainer, BorderRadiusSemanticsAll as default };
